import React from 'react'
import {Box} from '@mui/material'
import Card from 'src/components-new/layout/Card'
import SelectNew from 'src/components-new/inputs/SelectNew'
import CheckboxGroupNew from 'src/components-new/inputs/CheckboxGroupNew'
import ReadOnlyField from 'src/components-new/inputs/ReadOnlyField'

const SERVICE_CONF_OPTIONS = [
  {value: 'EXTRA', label: 'Extra'},
  {value: 'SMART', label: 'Smart'},
]

const DRUG_DELIVERY_OPTIONS = [
  {value: 'true', label: 'Attivo'},
]

interface OthersDataSectionProps {
  values: Record<string, any>
  setField: (key: string, value: any) => void
  fields: Record<string, any>
}

export default function OthersDataSection({values, setField, fields}: OthersDataSectionProps): JSX.Element | null {
  if (fields?.drugDeliveryService?.hidden && fields?.serviceConf?.hidden) {
    return null
  }

  return (
    <Card title="Configurazione servizi">
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)'},
          gap: 2,
        }}
      >
        {!fields?.serviceConf?.hidden && (
          fields?.serviceConf?.readOnly
            ? (
              <ReadOnlyField
                label="Configurazione di servizio"
                value={SERVICE_CONF_OPTIONS.find(o => o.value === values.serviceConf)?.label ?? null}
                fullWidth
              />
            )
            : (
              <SelectNew
                label="Configurazione di servizio"
                value={values.serviceConf ?? ''}
                onChange={v => setField('serviceConf', v)}
                options={SERVICE_CONF_OPTIONS}
                required
                fullWidth
              />
            )
        )}
        {!fields?.drugDeliveryService?.hidden && (
          <CheckboxGroupNew
            label="Servizio consegna farmaco"
            value={values.drugDeliveryService ?? []}
            onChange={v => setField('drugDeliveryService', v)}
            options={DRUG_DELIVERY_OPTIONS}
            disabled={fields?.drugDeliveryService?.readOnly}
          />
        )}
      </Box>
    </Card>
  )
}
